module.exports = __webpack_public_path__ + "img/schedule2_7-12-2021.439c3765.jpg";